import { FormikProps } from 'formik';
import { genericRuleCatalog, useGenericRulesCatalog } from '../../../hooks/useGenericRulesCatalog';

import {
  isOlderThan,
  validateCpf,
  validateDate,
  validateEmail,
  validateName,
  validatePassport
} from '../../../utils/validators';

export const INITIAL_VALUES = {
  documentType: 'CPF',
  document: '',
  citizenship: '',
  gender: '',
  pregnant: '',
  name: '',
  birthDate: '',
  birthDateDate: '',
  phone: '',
  email: '',
  idPatient: ''
};

type validateFormPatientProps = {
  values: typeof INITIAL_VALUES;
  formik: FormikProps<typeof INITIAL_VALUES>;
  checkGenericRulesCatalog: (ruleCondition: string) => genericRuleCatalog | undefined;
};

export function formPatientHasError({ values, formik, checkGenericRulesCatalog }: validateFormPatientProps) {
  let anyError = false;
  const dateString = validateDate(values.birthDateDate);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { validateGenericRules } = useGenericRulesCatalog();

  if (!dateString) {
    formik.setFieldError('birthDateDate', 'Data inválida');
    anyError = true;
  } else {
    values.birthDate = dateString;
  }

  if (formik.values.documentType === 'CPF') {
    if (!validateCpf(values.document)) {
      formik.setFieldError('document', 'Documento inválido');
      anyError = true;
    }
  } else if (formik.values.documentType === 'Passaporte') {
    if (!validatePassport(values.document)) {
      formik.setFieldError('document', 'Documento inválido');
      anyError = true;
    }
  }

  if (values.citizenship === '') {
    formik.setFieldError('citizenship', 'Selecione a nacionalidade');
    anyError = true;
  }

  const genericRuleCatalog = checkGenericRulesCatalog('gender');
  if (genericRuleCatalog) {
    if (!validateGenericRules(genericRuleCatalog, values.gender === 'Feminino' ? 'female' : 'male')) {
      formik.setFieldError('gender', 'O tipo de procedimento escolhido é somente para o sexo feminino');
      anyError = true;
    }
  }

  if (values.gender == '') {
    formik.setFieldError('gender', 'Selecione o gênero');
    anyError = true;
  }

  if (values.gender === 'Feminino') {
    if (values.pregnant === '' && isOlderThan(values.birthDate, 9)) {
      formik.setFieldError('pregnant', 'Selecione se é gestante');
      anyError = true;
    }
  }

  if (!validateName(values.name)) {
    formik.setFieldError('name', 'Digite nome completo');
    anyError = true;
  }

  if (!validateEmail(values.email)) {
    formik.setFieldError('email', 'Digite um email válido');
    anyError = true;
  }

  return anyError;
}
